module.exports = __webpack_public_path__ + "static/media/search-document-3.3f29796a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/backgrounds/search-document-3.svg
// module id = 504
// module chunks = 0